import { useReviewStatusCardStyles } from "./ReviewStatusCard.styles";
import { IReviewStatusCardProps } from "./ReviewStatusCard.types";

export const ReviewStatusCard = ({
  label,
  value,
}: IReviewStatusCardProps): JSX.Element => {
  const styles = useReviewStatusCardStyles();

  return (
    <div className={styles.card}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};
